import { configureStore } from "@reduxjs/toolkit";
import { reducers as adminReducer } from "../redux/slice/AdminSlice";
import { reducers as manualCheckReducer } from "./slice/AdminRunChecksSlice";
import { manualPanCheck } from "./actions/AdminRunChecksAction";
import { reducers as adminDashboardReducer } from "../redux/slice/AdminDashboardSlice";
import { reducers as adminNotificationReducer } from "../redux/slice/AdminNotificationSlice";
import { reducers as insufficientReducer } from "../redux/slice/InsufficientRunSlice";
import {reducers as clientManagemetReducer} from "../redux/slice/ClientManagementSlice";
import {reducers as CvAnalysisReducer} from "../redux/slice/CvAnalysisSlice";
import {reducers as fetchInvoiceReducer} from '../redux/slice/FinancialManagementSlice';
import {reducers as reportsReducer} from '../redux/slice/ReportsSlice';
import { reducers as MfaReducer } from "../redux/slice/AdminMfaSlice";
import { postUpdatedCheckList } from "./actions/ClientManagementActions";
import {invoiceApproveList } from "./actions/FinancialManagementAction";
import { manualOFACCheck } from "./actions/AdminActions";


const store = configureStore({
  reducer: {
    adminCandidateList: adminReducer.adminCandidateList,
    adminCandidateDetails: adminReducer.adminCandidateReport,
    adminCandidateReportDetails: adminReducer.adminCandidateReportDetails,
    CandidateFinalConclusion: adminReducer.CandidateFinalConclusion,
    adminLogin: adminReducer.adminLogin,
    adminLogout: adminReducer.adminLogout,
    fetchCheckDetails: adminReducer.fetchCheckDetails,
    manualCourtCheck: adminReducer.manualCourtCheck,
    JobSeeekerIdChange: adminReducer.JobSeeekerIdChange,
    PendingChecksReport: adminReducer.PendingChecksReport,
    manualPanCheck: manualCheckReducer.manualPanCheck,
    manualAadhaarCheck: manualCheckReducer.manualAadhaarCheck,
    adminDashboardCheckMarquee:
      adminDashboardReducer.adminDashboardCheckMarquee,
    adminDashboardTatData: adminDashboardReducer.adminDashboardTatData,
    getChecksList: adminDashboardReducer.getChecksList,
    CheckInteractivity: adminDashboardReducer.CheckInteractivity,
    GetStatusCounts: adminDashboardReducer.GetStatusCounts,
    GetAccessData: adminDashboardReducer.GetAccessData,
    GetPreOnboardingCandidatesList: adminDashboardReducer.GetPreOnboardingCandidatesList,
    manualDrugCheck: manualCheckReducer.manualDrugCheck,
    manualReferenceCheck: manualCheckReducer.manualReferenceCheck,
    manualBankCheck: manualCheckReducer.manualBankCheck,
    manualDLCheck: manualCheckReducer.manualDLCheck,
    manualIRRDCheck: manualCheckReducer.manualIRRDCheck,
    manualVoterIdCheck: manualCheckReducer.manualVoterIdCheck,
    manualUANCheck: manualCheckReducer.manualUANCheck,
    uanInformationVerification: manualCheckReducer.uanInformationVerification,
    manualGlobalCheck: manualCheckReducer.manualGlobalCheck,
    manualFACISCheck: manualCheckReducer.manualFACISCheck,
    manualIndianCreditHistoryCheck: manualCheckReducer.manualIndianCreditHistoryCheck,
    manualAddressCheck: manualCheckReducer.manualAddressCheck,
    SubmitEmploymentGap: manualCheckReducer.SubmitEmploymentGap,
    ConcludeEmploymentGap: manualCheckReducer.ConcludeEmploymentGap,
    manualEducationUpload: manualCheckReducer.manualEducationUpload,
    manualEmploymentUpload: manualCheckReducer.manualEmploymentUpload,
    manualCheckSaveEduEmp: manualCheckReducer.manualCheckSaveEduEmp,
    adminNotificationList: adminNotificationReducer.adminNotificationList,
    adminDeleteNotification: adminNotificationReducer.adminDeleteNotification,
    adminReadByUser: adminNotificationReducer.adminReadByUser,
    adminReadAllMessage: adminNotificationReducer.adminReadAllMessage,
    adminDeleteAllMessage: adminNotificationReducer.adminDeleteAllMessage,
    educationInsufficient: manualCheckReducer.educationInsufficient,
    getInsufficientDetails: manualCheckReducer.getInsufficientDetails,
    fetchInsufficientApprove: manualCheckReducer.fetchInsufficientApprove,
    approveEducationInsufficient: manualCheckReducer.approveEducationInsufficient,
    rejectInsufficient: manualCheckReducer.rejectInsufficient,
    approveEmploymentInsufficient: manualCheckReducer.approveEmploymentInsufficient,
    otherInsufficientAdd: insufficientReducer.otherInsufficientAdd,
    otherInsufficientReject: insufficientReducer.otherInsufficientReject,
    otherInsufficientApprove: insufficientReducer.otherInsufficientApprove,
    manualInsufficientReferenceData: insufficientReducer.manualInsufficientReferenceData,
    referenceInsufficientReject: insufficientReducer.referenceInsufficientReject,
    referenceInsufficientApprove: insufficientReducer.referenceInsufficientApprove,
    educationEmploymentCostAdd: insufficientReducer.educationEmploymentCostAdd,
    listAdditionalCost: insufficientReducer.listAdditionalCost,
    approverForFinanceVerification:insufficientReducer.approverForFinanceVerification,
    updateOtherExpenses: insufficientReducer.updateOtherExpenses,
    recallAdditionalCost: insufficientReducer.recallAdditionalCost,
    cancelAdditionalCost: insufficientReducer.cancelAdditionalCost,
    financeRecallDecision: insufficientReducer.financeRecallDecision,
    listAdditionalExpenseDetails: insufficientReducer.listAdditionalExpenseDetails,
    addCommentsPendingChecks: insufficientReducer.addCommentsPendingChecks,
    deleteCommentsPendingChecks: insufficientReducer.deleteCommentsPendingChecks,
    listAllVendors: clientManagemetReducer.listAllVendors,
    companyInformationDetails:clientManagemetReducer.companyInformationDetails,
    uploadMspDocument:clientManagemetReducer.uploadMspDocument,
    getClientPaymentDetails:clientManagemetReducer.getClientPaymentDetails,
    updateClientDetails:clientManagemetReducer.updateClientDetails,
    getClientDetails:clientManagemetReducer.getClientDetails,
    getClientChecksList:clientManagemetReducer.getClientChecksList,
    postUpdatedCheckList:clientManagemetReducer.postUpdatedCheckList,
    getCvAnalysisData:CvAnalysisReducer.getCvAnalysisData,
    addCvDiscrepancy:CvAnalysisReducer.addCvDiscrepancy,
    sendMessage:CvAnalysisReducer.sendMessage,
    concludeDiscrepancy:CvAnalysisReducer.concludeDiscrepancy,
    followUpDiscrepancy:CvAnalysisReducer.followUpDiscrepancy,
    getAIdiscrepancy:CvAnalysisReducer.getAIdiscrepancy,
    fetchInvoiceData:fetchInvoiceReducer.fetchInvoiceData,
    fechInvoiceSingleDataList: fetchInvoiceReducer.fechInvoiceSingleDataList,
    updateInvoiceGeneration: fetchInvoiceReducer.updateInvoiceGeneration,
    adminApproveInvoice: fetchInvoiceReducer.adminApproveInvoice,
    invoiceApproveList: fetchInvoiceReducer.invoiceApproveList,
    fetchApproveInvoiceSingleList:fetchInvoiceReducer.fetchApproveInvoiceSingleList,
    financeApproveInvoice:fetchInvoiceReducer.financeApproveInvoice,
    sendInvoiceEmail:fetchInvoiceReducer.sendInvoiceEmail,
    GenerateInvoiceProofUrl:fetchInvoiceReducer.GenerateInvoiceProofUrl,
    updateInvoicePaymentDetails:fetchInvoiceReducer.updateInvoicePaymentDetails,
    generateLateFeeInvoice: fetchInvoiceReducer.generateLateFeeInvoice,
    getLateFeeInvoices: fetchInvoiceReducer.getLateFeeInvoices,
    updateLateInvoicePaymentDetails: fetchInvoiceReducer.updateLateInvoicePaymentDetails,
    activateDeactivateVendorStatus: fetchInvoiceReducer.activateDeactivateVendorStatus,
    generateFrobinInvoice: fetchInvoiceReducer.generateFrobinInvoice,
    fetchReportsData:reportsReducer.fetchReportsData,
    getClientWiseCompletedReport:reportsReducer.getClientWiseCompletedReport,
    enableMfa: MfaReducer.enableMfa,
    registerMfa: MfaReducer.registerMfa,
    verifyMfaAuthentication: MfaReducer.verifyMfaAuthentication,
    ManualWork: adminReducer.ManualWork,
    CandidateUpdateChecks:adminReducer.CandidateUpdateChecks,
    FetchCheckFields: adminReducer.FetchCheckFields,
    manualOFACCheck: adminReducer.manualOFACCheck,
    manualForm26ASCheck:adminReducer.manualForm26ASCheck,
    manualForm16Check: adminReducer.manualForm16Check,
    manualBankVerificationCheck:adminReducer.manualBankVerificationCheck,
    manualSalaryVerificationCheck:adminReducer.manualSalaryVerificationCheck,
    UpdateResumeUrl:adminReducer.UpdateResumeUrl,
    ManualDocumentsFetchUrl: adminReducer.ManualDocumentsFetchUrl,
    ManualDocumentsGenerateUrl:adminReducer.ManualDocumentsGenerateUrl,
    GenerateDailyVendorReport:adminReducer.GenerateDailyVendorReport,
    GenerateDailyClientReport:adminReducer.GenerateDailyClientReport,
    GenerateCandidateStatusCancelReport:adminReducer.GenerateCandidateStatusCancelReport,
    CandidateTechFinalConclusion: adminReducer.CandidateTechFinalConclusion,
    AdminInvoiceGeneration: adminReducer.AdminInvoiceGeneration,
    UpdateCandidateAddress: adminReducer.UpdateCandidateAddress,
    UpdateCandidatePersonalInfo:adminReducer.UpdateCandidatePersonalInfo,
    ClosedInsufficiencyComments:adminReducer.ClosedInsufficiencyComments,
    // GenerateInvoiceProofUrl:adminReducer.GenerateInvoiceProofUrl
  },
});

export default store;
